import React, { useState } from "react";
import axios from "axios";
import "./RateSearch.css";

interface RateItem {
  Vendor_Code: string;
  Vendor_Name: string;
  Shipment_Type: string;
  Zone_Name: string;
  Country_Name: string;
  Lower_Wt: number;
  Upper_Wt: number;
  Rate: number;
}

const VndrRateSearchonline: React.FC = () => {
  const [shipmentType, setShipmentType] = useState("Dox");
  const [searchMode, setSearchMode] = useState<"weight" | "country">("weight");
  const [searchValue, setSearchValue] = useState("");
  const [rateData, setRateData] = useState<RateItem[]>([]);
  const [error, setError] = useState("");

  const fetchData = async () => {
    if (!searchValue) {
      setError("Please enter value");
      return;
    }

    let url = `https://speedlogisticsindia.com/Tracking/Master/VendorRateSearchonWebsite?ShipmentType=${shipmentType}`;

    if (searchMode === "weight") {
      if (isNaN(Number(searchValue))) {
        setError("Invalid weight");
        return;
      }
      url += `&Weight=${searchValue}`;
    } else {
      url += `&Country=${searchValue}`;
    }

    try {
      const res = await axios.get(url);
      if (res.data?.status === 1) {
        setRateData(res.data.data);
        setError("");
      } else {
        setRateData([]);
        setError("No rate found");
      }
    } catch {
      setError("API error");
    }
  };

  return (
    <div className="rate-container">
      <div className="rate-card">

        {/* ================= SEARCH BAR ================= */}
        <div className="rate-search-bar">

          <select
            className="rate-select"
            value={shipmentType}
            onChange={(e) => setShipmentType(e.target.value)}
          >
            <option value="Dox">DOX</option>
            <option value="Spx">SPX</option>
          </select>

          <select
            className="rate-select"
            value={searchMode}
            onChange={(e) => {
              setSearchMode(e.target.value as any);
              setSearchValue("");
            }}
          >
            <option value="weight">Weight</option>
            <option value="country">Country</option>
          </select>

          <div className="pill-search-wrapper">
            <input
              type="text"
              className="pill-input"
              placeholder={
                searchMode === "weight"
                  ? "Enter Weight (Kg)"
                  : "Enter Country (e.g. Bhutan)"
              }
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />

            <button className="pill-button" onClick={fetchData}>
              Search
            </button>
          </div>

        </div>

        {error && <p className="error-text">{error}</p>}

        {/* ================= RESULT TABLE ================= */}
        <div className="table-responsive">
          <table className="rate-table">
            <thead>
              <tr>
                <th>Sr</th>
                <th>Vendor</th>
                <th>Shipment</th>
                <th>Country</th>
                <th>Zone</th>
                <th>Lower Wt</th>
                <th>Upper Wt</th>
                <th>Rate</th>
              </tr>
            </thead>
            <tbody>
              {rateData.length > 0 ? (
                rateData.map((item, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{item.Vendor_Name}</td>
                    <td>{item.Shipment_Type}</td>
                    <td>{item.Country_Name}</td>
                    <td>{item.Zone_Name}</td>
                    <td>{item.Lower_Wt}</td>
                    <td>{item.Upper_Wt}</td>
                    <td>₹ {item.Rate}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="no-data">
                    No data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default VndrRateSearchonline;
